export enum ButtonSize {
    ExtraSmall = "extra-small",
    Small = "small",
    Medium = "medium",
    Large = "large",
    ExtraLarge = "extra-large",
}

export enum ButtonStyle {
    Primary = "primary",
    PrimaryLink = "primary-link",
    Secondary = "secondary",
    Green = "green",
    Yellow = "yellow",
    Red = "red",
    Black = "black",
    SecondaryLink = "SecondaryLink",
}
